import i18n from '@/utils/i18n';
import store from '@/store'
import { receiveAccountList, accountSuitList } from '@/api/interface.js'
import { resetRouter } from '@/router/index'
let nowpayAccountRoute = null // 现付账对象
let financeAccountRoute = null // 财务模块路由

/**
 *
 *
 * @param {*} suitName 账套名称
 * @param {*} isNowPayAccount 是否是现付账
 */
export function editSuitName(suitName, suitId, isNowPayAccount) {
  const routeList = store.getters.authList
  const parentRoute = routeList.find(
    pRoute => pRoute.path === (!isNowPayAccount ? '/finance' : '/account')
  )
  let cTargetRouteName = isNowPayAccount ? '/account/accountSet/index' : '/finance/mangement/index'
  const targetRoute = parentRoute.children.find(
    cRoute => cRoute.path === cTargetRouteName
  )
  if (targetRoute.children) {
    const nameAdjustRoute = targetRoute.children.find(item => item.path.endsWith(suitId))
    if (nameAdjustRoute) {
      nameAdjustRoute.meta.title = suitName
    }
  }
}
/**
 *
 *
 * @param {*} isFinance 是否是财务
 * @param {*} isAccount 是否是现付账
 * @param {*} routeList 路由列表
 */
export function autoAddRouter(isFinance, isAccount, routeList) {
  const parentRoute = routeList.find(
    pRoute => pRoute.path === (isFinance ? '/finance' : '/account')
  )
  let cTargetRouteName = '/finance/mangement/index'
  let fetchRouteMethod = receiveAccountList
  if (isAccount) {
    cTargetRouteName = '/account/accountSet/index'
    fetchRouteMethod = accountSuitList
  }
  const targetRoute = parentRoute.children.find(
    cRoute => cRoute.path === cTargetRouteName
  )
  if (isAccount) {
    nowpayAccountRoute = targetRoute
  } else {
    financeAccountRoute = targetRoute
  }
  if (!store.getters.hotelCode) { // 如果没有hotelCode,直接跳过
    return Promise.resolve(routeList)
  }
  return new Promise(resolve => {
    fetchRouteMethod({
      hotelCode: store.getters.hotelCode
    }).then(res => {
      // res.data.splice(0, 1)
      if (res.code === '0') {
        const lestList = []
        if (res.data.length) {
          let initMethod = initFinanceSuitRouteInstance
          if (isAccount) {
            res.data = sortAccountList(res.data)
            initMethod = initNowPayAccoutRouteInstance
          }
          res.data.forEach(e => {
            lestList.push(initMethod(e))
          })
        }
        targetRoute.children = lestList
        resolve(routeList)
      }
    })
  })
}
// 更新现付账的路由对象
export function updateDynamicRoute(operateType, idOrName, isNowPayAccount = true) {
  const fetchAccountListMethod = isNowPayAccount ? accountSuitList : receiveAccountList
  const targetRoute = !isNowPayAccount ? financeAccountRoute : nowpayAccountRoute
  const initRouteMethod = isNowPayAccount ? initNowPayAccoutRouteInstance : initFinanceSuitRouteInstance
  if (operateType === 'able' || operateType === 'add') {
    fetchAccountListMethod().then(res => {
      if (res.code === '0') {
        let accuntList = targetRoute && targetRoute.children || []
        let compareKey = 'id'
        if (operateType === 'add') {
          if (isNowPayAccount) {
            compareKey = 'name'
          } else {
            compareKey = 'accountName'
          }
        }
        const suit = res.data.find(item => item[compareKey] === idOrName)
        accuntList.push(initRouteMethod(suit))
        if (isNowPayAccount) {
          sortAccountListRoute(targetRoute)
        }
        resetRouter(store.getters.authList)
      }
    })
  } else {
    const accuntList = targetRoute && targetRoute.children || []
    const index = accuntList.findIndex(item => item.path.endsWith(idOrName))
    accuntList.splice(index, 1)
  }
}
// 初始化现付账账套路由对象
function initNowPayAccoutRouteInstance({ id, subjectName, subjectCode, hotelName, name }) {
  return {
    name: `Member${id}`,
    path: `/account/accountSet/Member/${subjectCode}/${id}`,
    props: {
      subjectName,
      subjectCode,
      externalNumber: id,
      hotelName,
      accountName: name
    },
    component: () => import('@/views/account/accountSet/Member'),
    meta: { title: name, navMenu: 'account' }
  }
}

/**
 *
 * 初始化财务应收账列表路由对象
 * @param {*} { id, type, accountType, accountName }
 * @returns
 */
function initFinanceSuitRouteInstance({ id, type, accountType, accountName }) {
  return {
    name: `aMangement${id}`,
    path: `/finance/mangement/Member/${id}`,
    props: {
      receiveAccountId: id,
      type: type + '',
      accountType: accountType + ''
    },
    component: () => import('@/views/finance/mangement/Member'),
    meta: { title: accountName, navMenu: 'Finance' }
  }
}

/**
 *
 *  列表排序，先把数据做排序
    第一优先级：小商品账套＞其他账套
    第二优先级：按照ID正序
 * @param {*} accountList
 * @returns
 */
function sortAccountList(accountList, sortKey = 'id') {
  const smallGoodsAccountList = []
  const normalAccountList = []
  for (const accountItem of accountList) {
    if (accountItem.subjectCode === '10011') {
      smallGoodsAccountList.push(accountItem)
    } else {
      normalAccountList.push(accountItem)
    }
  }
  smallGoodsAccountList.sort((a, b) => {
    return a[sortKey] - b[sortKey]
  })
  normalAccountList.sort((a, b) => {
    return a[sortKey] - b[sortKey]
  })
  return [...smallGoodsAccountList, ...normalAccountList]
}
/**
 *
 *  列表排序
    第一优先级：小商品账套＞其他账套
    第二优先级：按照ID正序
 * @param {*} accountList
 * @returns
 */
function sortAccountListRoute(route) {
  const accountList = route.children
  const smallGoodsAccountList = []
  const normalAccountList = []
  if (accountList && accountList.length) {
    for (const accountItem of accountList) {
      if (getCodeByReg(accountItem.path)[0] === '10011') {
        smallGoodsAccountList.push(accountItem)
      } else {
        normalAccountList.push(accountItem)
      }
    }
    smallGoodsAccountList.sort((a, b) => {
      return getCodeByReg(a.path)[1] - getCodeByReg(b.path)[1]
    })
    normalAccountList.sort((a, b) => {
      return getCodeByReg(a.path)[1] - getCodeByReg(b.path)[1]
    })
    route.children = [...smallGoodsAccountList, ...normalAccountList]
  }
  return route
}
function getCodeByReg(path) {
  return path.match(/\d+/g)
}
/**
 */
export async function handleIintFinanceRoute() {
  const financeRoute = store.getters.authList.find(item => item.path === '/finance')
  if (financeRoute && financeRoute.children) {
    const finaceAccountRoute = financeRoute.children.find(item => item.path === '/finance/mangement/index')
    if (finaceAccountRoute && (!finaceAccountRoute.children || !finaceAccountRoute.children.length)) {
      const newRouterList = await autoAddRouter(true, false, store.getters.authList) // 查询财务的账套列表
      console.log(i18n.t("utilsAddroute.initializesTheReceivableFinancialMenu"), newRouterList)
      if (newRouterList.length > 0) {
        resetRouter([{
          path: '/',
          redirect: `${newRouterList[0].path}`,
          hidden: true
        }, ...newRouterList, { path: '*', redirect: '/404', hidden: true }])
      }
    }
  }
}
